export const LOCAL_OFFLINE_BUILD_KEY = "moo_local_offline_asset_rev";

export const isLocalOfflineCacheName = (name) =>
  String(name || "").startsWith("moo-local-");

export const isLocalOfflineServiceWorker = (registration) => {
  const worker =
    registration?.active || registration?.waiting || registration?.installing;
  return String(worker?.scriptURL || "").includes("/moo-local-sw.js");
};

export const resetStaleLocalOfflineCache = async ({
  assetRev,
  storage,
  cacheStorage,
  serviceWorker,
} = {}) => {
  const currentAssetRev = String(assetRev || "dev");
  if (!storage) return false;

  let previousAssetRev = null;
  try {
    previousAssetRev = storage.getItem(LOCAL_OFFLINE_BUILD_KEY);
    if (previousAssetRev === currentAssetRev) return false;
    storage.setItem(LOCAL_OFFLINE_BUILD_KEY, currentAssetRev);
  } catch (_error) {
    return false;
  }

  let changed = false;
  try {
    const keys = (await cacheStorage?.keys?.()) || [];
    const staleKeys = keys.filter(isLocalOfflineCacheName);
    if (staleKeys.length > 0) {
      await Promise.all(staleKeys.map((key) => cacheStorage.delete(key)));
      changed = true;
    }
  } catch (_error) {
    // Le nettoyage de cache ne doit jamais bloquer le démarrage local.
  }

  try {
    const registrations = (await serviceWorker?.getRegistrations?.()) || [];
    const localRegistrations = registrations.filter(isLocalOfflineServiceWorker);
    if (localRegistrations.length > 0) {
      await Promise.all(localRegistrations.map((registration) => registration.unregister()));
      changed = true;
    }
  } catch (_error) {
    // Le service worker courant sera tout de même réenregistré par l'appelant.
  }

  return changed;
};
